import { Component, OnInit } from "@angular/core";
import { NavHeaderComponent } from "../../../shared/components/nav-header/nav-header.component";
import { MatButtonModule } from "@angular/material/button";
import { PolicyEnum } from "../../coverages/_constants";
import { ActivatedRoute } from "@angular/router";
import { PDFDocumentProxy, PdfViewerModule } from "ng2-pdf-viewer";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { PinchZoomComponent } from '@meddv/ngx-pinch-zoom';
import { LayoutService } from "../../../shared/services/layout.service";

@Component({
    selector: "app-policy-faq-full",
    standalone: true,
    imports: [NavHeaderComponent, MatButtonModule, PdfViewerModule, MatProgressSpinner, PinchZoomComponent],
    templateUrl: "./policy-faq-full.component.html",
    styleUrl: "./policy-faq-full.component.scss",
})
export class PolicyFaqFullComponent implements OnInit {
    isLoading = false;
    policyCode: PolicyEnum = this.route.snapshot.data["policy"] || PolicyEnum.TravelProtectPlus;
    pdfSrc = "";

    constructor(private route: ActivatedRoute,
        private layoutService: LayoutService,
    ) {}

    ngOnInit(): void {
        this.isLoading = true;
        const pdfMap = {
            [PolicyEnum.TravelProtectPlus]: "travel-protect-plus-faq.pdf",
            [PolicyEnum.BillProtect]: "FAQ%20Bill%20Protect.pdf",
            [PolicyEnum.LifestyleProtectPlus]: "FAQ%20Lifestyle%20Protect.pdf",
        };
        this.pdfSrc = `/assets/docs/${pdfMap[this.policyCode]}`;
    }

    callBackFn(pdf: PDFDocumentProxy): void {
        this.isLoading = false;
        this.layoutService.scrollToTop();
    }
}
